import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { VendorModule } from 'projects/vendors/src/public-api';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';


import { AngularSplitModule } from 'angular-split';
import { HomeComponent } from './pages/home/home.component';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';


//import { FormEditorComponent } from './modules/procedure-module/pages/form-editor/form-editor.component';
//import { CommonPropertiesComponent } from './modules/procedure-module/pages/form-editor/properties/common-properties/common-properties.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './modules/common-shared-module/interceptor/http-request.interceptor';
import { CommonSharedModule } from './modules/common-shared-module/common-shared-module.module';
//import { SessionTimeOutComponent } from './modules/common-shared-module/components/session-time-out/session-time-out.component';
import { HttpSecurityInterceptor } from './modules/common-shared-module/interceptor/http-security.interceptor';
//import { SecurityAlertComponent } from './modules/common-shared-module/components/security-alert/security-alert.component';
import { SpinnerInterceptor } from './modules/common-shared-module/interceptor/spinner.interceptor';
import { HttpErrorInterceptor } from './modules/common-shared-module/interceptor/http-error.interceptor';
//import { ServerErrorComponent } from './modules/common-shared-module/components/server-error/server-error.component';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BackRedirectorComponent } from './components/back-redirector/back-redirector.component';
import { ConfigService } from './modules/common-shared-module/core/services/config/config.service';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';



//import { QuillModule } from 'ngx-quill'

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  //appearance: 'standard',
};

export function initLoggin(configService: ConfigService): () => Promise<void> {
  return () => configService.initLoggin()
}


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,    
    BackRedirectorComponent, 
    RedirectComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AngularSplitModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    VendorModule,
    CommonSharedModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initLoggin,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpSecurityInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true

    },
    {
      provide: 'externalUrlRedirectResolver',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        window.location.href = (route.data as any).externalUrl;
      },

    },
    {
      provide: 'backRedirector',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        localStorage.setItem('urlSegment', state.url);

        window.location.href = '/webst/webstbk/index.html';
      },

    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
